<template>
  <div>
    <div class="row"></div>
    <div class="row">
      <div class="col m3 offset-m3">
        <div class="ministry">
          <div class="card">
            <div class="card-image">
              <img src="./../assets/img/ss.jpg">
            </div>
            <div class="card-content">
              <h5>Sunday School</h5>
            </div>
            <div class="card-action">
              <a class = "waves-effect waves-light btn modal-trigger" href="#sunday_school">Learn more</a>
            </div>
          </div>
          <!-- Modal Structure -->
          <div id="sunday_school" class="modal">
            <div class="modal-content">
              <h4>Sunday School</h4>
              <blockquote>LET CHILDREN COME TO ME</blockquote>
              <p>All your children shall be taught by the LORD, and great shall be the peace of your children...  Isaiah 54:13</p>
            </div>
            <div class="modal-footer">
              <a href="#" class="modal-close waves-effect waves-green btn-flat">Close</a>
            </div>
          </div>
        </div>
      </div>
      <div class="col m3">
        <div class="ministry">
          <div class="card">
            <div class="card-image">
              <img src="./../assets/img/ss.jpg">
            </div>
            <div class="card-content">
              <h5>Sunday School</h5>
            </div>
            <div class="card-action">
              <a class = "waves-effect waves-light btn modal-trigger" href="#sunday_school">Learn more</a>
            </div>
          </div>
          <!-- Modal Structure -->
          <div id="sunday_school" class="modal">
            <div class="modal-content">
              <h4>Sunday School</h4>
              <blockquote>LET CHILDREN COME TO ME</blockquote>
              <p>All your children shall be taught by the LORD, and great shall be the peace of your children...  Isaiah 54:13</p>
            </div>
            <div class="modal-footer">
              <a href="#" class="modal-close waves-effect waves-green btn-flat">Close</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col m3 offset-m3">
        <div class="ministry">
          <div class="card">
            <div class="card-image">
              <img src="./../assets/img/ss.jpg">
            </div>
            <div class="card-content">
              <h5>Sunday School</h5>
            </div>
            <div class="card-action">
              <a class = "waves-effect waves-light btn modal-trigger" href="#sunday_school">Learn more</a>
            </div>
          </div>
          <!-- Modal Structure -->
          <div id="sunday_school" class="modal">
            <div class="modal-content">
              <h4>Sunday School</h4>
              <blockquote>LET CHILDREN COME TO ME</blockquote>
              <p>All your children shall be taught by the LORD, and great shall be the peace of your children...  Isaiah 54:13</p>
            </div>
            <div class="modal-footer">
              <a href="#" class="modal-close waves-effect waves-green btn-flat">Close</a>
            </div>
          </div>
        </div>
      </div>
      <div class="col m3">
        <div class="ministry">
          <div class="card">
            <div class="card-image">
              <img src="./../assets/img/ss.jpg">
            </div>
            <div class="card-content">
              <h5>Sunday School</h5>
            </div>
            <div class="card-action">
              <a class = "waves-effect waves-light btn modal-trigger" href="#sunday_school">Learn more</a>
            </div>
          </div>
          <!-- Modal Structure -->
          <div id="sunday_school" class="modal">
            <div class="modal-content">
              <h4>Sunday School</h4>
              <blockquote>LET CHILDREN COME TO ME</blockquote>
              <p>All your children shall be taught by the LORD, and great shall be the peace of your children...  Isaiah 54:13</p>
            </div>
            <div class="modal-footer">
              <a href="#" class="modal-close waves-effect waves-green btn-flat">Close</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col m3 offset-m3">
        <div class="ministry">
          <div class="card">
            <div class="card-image">
              <img src="./../assets/img/ss.jpg">
            </div>
            <div class="card-content">
              <h5>Sunday School</h5>
            </div>
            <div class="card-action">
              <a class = "waves-effect waves-light btn modal-trigger" href="#sunday_school">Learn more</a>
            </div>
          </div>
          <!-- Modal Structure -->
          <div id="sunday_school" class="modal">
            <div class="modal-content">
              <h4>Sunday School</h4>
              <blockquote>LET CHILDREN COME TO ME</blockquote>
              <p>All your children shall be taught by the LORD, and great shall be the peace of your children...  Isaiah 54:13</p>
            </div>
            <div class="modal-footer">
              <a href="#" class="modal-close waves-effect waves-green btn-flat">Close</a>
            </div>
          </div>
        </div>
      </div>
      <div class="col m3">
        <div class="ministry">
          <div class="card">
            <div class="card-image">
              <img src="./../assets/img/ss.jpg">
            </div>
            <div class="card-content">
              <h5>Sunday School</h5>
            </div>
            <div class="card-action">
              <a class = "waves-effect waves-light btn modal-trigger" href="#sunday_school">Learn more</a>
            </div>
          </div>
          <!-- Modal Structure -->
          <div id="sunday_school" class="modal">
            <div class="modal-content">
              <h4>Sunday School</h4>
              <blockquote>LET CHILDREN COME TO ME</blockquote>
              <p>All your children shall be taught by the LORD, and great shall be the peace of your children...  Isaiah 54:13</p>
            </div>
            <div class="modal-footer">
              <a href="#" class="modal-close waves-effect waves-green btn-flat">Close</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
function init(){
  var elems = document.querySelectorAll('.modal');
  var instances = M.Modal.init(elems, {});
}
export default {
  name: "Ministries",
  mounted: init
}
</script>



// WEBPACK FOOTER //
// src/components/Ministries.vue